module.exports = __webpack_public_path__ + "media/images/bg-473d1ca3ed214d75881f8307208b683f.jpg";